import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { Actions, ofType } from '@ngrx/effects';
import { APP_CONFIG } from '../../../../../src/app/config/app-config.module';
import { AppConfig } from '../../../../../src/app/core/config-models/app-config.model';
import { ILegalEntitiesCreateBusinessRequest } from '../../../../../src/app/features/todos/models/create-business.model';
import * as fromStaticDataSelector from '../../../static-data/selectors';
import * as fromToDosAction from '../../../features/todos/actions';
import { ILegalEntityTypesResponse } from '../../../../../src/app/static-data/models/legal-entity-types.model';
import * as fromStaticDataBusinessNamesSelector from '../../../static-data/selectors/business-names.selectors';
import { IBusinessNamesResponse } from '../../../static-data/models/business-names.model';
import { fromStaticDataBusinessNamesActions } from '../../../static-data/actions';
import { ILegalEntitiesBusinessesResponse } from '../../models/shared.model';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-create-legal-entity',
  templateUrl: './create-legal-entity.component.html',
  styleUrls: ['./create-legal-entity.component.css']
})
export class CreateLegalEntityComponent implements OnInit {
  @Output() closeLegalEntityPopupEvent:EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() messageEvent: EventEmitter<any> = new EventEmitter<any>();

  fileName: string;
  toUploadEndpoint: string;
  newLegalEntity: string;
  decision: string = 'false';
  showFSPInput: boolean = false;
  fspNumber: string;
  fspValues: any[];
  selectionFSP: number = 2;
  selectionAssetManager: number = 2;

  subscription: Subscription = new Subscription();
  selectedCountry: ILegalEntityTypesResponse;
  selectedParentEntityId: string;
  selectedCountryId: string;
  newCountryNameResults = [];
  countryId: string;
  disableButton: boolean = true;
  businessNames$: Observable<IBusinessNamesResponse[]>;
  newLegalEntityResponse: ILegalEntitiesBusinessesResponse;
  constructor(
    @Inject(APP_CONFIG) private appConfig: AppConfig,
    private store: Store,
    private actions$: Actions//,
  ) {
    this.fspValues = [{
      id: 1, valueText: 'Yes', value: true
    },{
      id: 2, valueText: 'No', value: false
    }];
  }

  ngOnInit(): void {
    this.populateLegalEntityTypes();
    this.store.dispatch(fromStaticDataBusinessNamesActions.loadBusinessNames());
    this.businessNames$ = this.store.select(fromStaticDataBusinessNamesSelector.getStaticDataBusinessNamesResponse);
  }

  uploadDoc(fileId) {
    this.fileName = `ProofBusinessRegistration/${fileId}`;
  }

  myUploader(event) {
  }

  searchCountryNames(e) {
    this.subscription.add(
      this.store.select(fromStaticDataSelector.selectLegalEntityTypes).subscribe(country => {
        if (country) {
          this.newCountryNameResults = country.filter(value => {
            let newValues = value.description.toLowerCase();
            return newValues.startsWith(e.query.toLowerCase());
          });
        }
      })
    );
  }

  populateLegalEntityTypes(){
    this.subscription.add(
      this.store.select(fromStaticDataSelector.selectLegalEntityTypes).subscribe(country => {
        if (country) {
          this.newCountryNameResults = country.filter(value => {
            let newValues = value.description.toLowerCase();
            return newValues.startsWith("");
          });
        }
      })
    );
  }

  onFSPValueChanged(e){
    if (e.value === 1) {
      this.disableButton = true;
      this.showFSPInput = true;
    } else {
      this.showFSPInput = false;
      this.fspNumber = undefined;
      this.selectedCountry = undefined;
      this.disableButton = true;
    }
  }

  decisionSelection() {
    if (this.decision === 'true') {
      this.disableButton = true;
      this.showFSPInput = true;
    } else {
      this.showFSPInput = false;
      this.fspNumber = undefined;
      this.selectedCountry = undefined;
      this.disableButton = true;
    }
  }

  cancelPopup() { this.closeLegalEntityPopupEvent.emit(); }

  submitNewLegalEntity() {
    this.countryId = this.selectedCountryId === undefined ? this.newCountryNameResults[0].id : this.selectedCountryId;

    const req: ILegalEntitiesCreateBusinessRequest = {
      fspNumber: this.fspNumber,
      legalEntityName: this.newLegalEntity,
      legalEntityTypeId: this.countryId,
      parentLegalEntityId: this.selectedParentEntityId,
      isAssetManager: this.selectionAssetManager === 1
    };
    this.store.dispatch(fromToDosAction.loadCreateBusiness({ request: req }));

    // Subscribe to the success action to capture the legalEntityId from the response
    this.actions$.pipe(
      ofType(fromToDosAction.loadCreateBusinessSuccess),
      take(1)
    ).subscribe(action => {
      const legalEntityId = action.response; // The response is the legalEntityId string

      var event = {
        message: `Legal entity "${this.newLegalEntity}" has been created.`,
        legalEntity: {
          legalEntityId: legalEntityId,
          fspNumber: this.fspNumber,
          legalEntityName: this.newLegalEntity,
          legalEntityTypeId: this.countryId,
          parentLegalEntityId: this.selectedParentEntityId,
          isAssetManager: this.selectionAssetManager === 1
        } // ILegalEntitiesBusinessesResponse
      };
      this.messageEvent.emit(event);
      this.delayToInitSearchComponent();
      this.cancelPopup();
    });

  }

  onFSPCHanged(e){
    this.fspNumber = e.event.currentTarget.value;
    this.enableButton();
  }

  enableButton() {
    let reg = new RegExp('^[0-9]+$');
    let isNumOnly = reg.test(this.fspNumber);

    if(this.newLegalEntity){
      if (!this.showFSPInput && this.newLegalEntity.length !== 0) {
        this.disableButton = this.selectedCountryId !== undefined ? false : true;
      } else if (this.showFSPInput && this.newLegalEntity.length !== 0) {
        if (this.selectedCountryId !== undefined && this.fspNumber.length > 3 && isNumOnly) {
          this.disableButton = false;
        } else {
          this.disableButton = true;
        }
      } else {
        this.disableButton = true;
      }
    }else{
      this.disableButton = true;
    }
  }

  delayToInitSearchComponent() {
  }

  selectEntityType(entityType: ILegalEntityTypesResponse) {
    this.selectedCountryId = entityType.id;
    this.selectedCountry = entityType;
    this.enableButton();
  }

  getEntityIcon(description: string): string {
    const desc = description.toLowerCase();
    switch (desc) {
      case 'adviser company':
        return 'fa-solid fa-user-group';
      case 'adviser individual':
        return 'fa-solid fa-user';
      case 'asset manager':
        return 'fa-solid fa-hand-holding-dollar';
      case 'business':
        return 'fa-solid fa-building';
      case 'wealth manager':
        return 'fa-solid fa-sack-dollar';
      default:
        return 'fa-solid fa-user';
    }
  }
}
